import ApolloClient, { InMemoryCache } from 'apollo-boost';

import clientState from '~/state';

export const client = new ApolloClient({
  clientState,
  cache: new InMemoryCache(),
});
